// ============================================
// License Page - Display License Certificate
// ============================================

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import './License.css';

const License = () => {
  const navigate = useNavigate();

  return (
    <div className="license-page">
      {/* Header */}
      <div className="license-header">
        <button className="back-btn" onClick={() => navigate(-1)}>
          <FaArrowLeft />
        </button>
        <h1 className="license-title">ใบอนุญาต</h1>
        <div style={{ width: '40px' }}></div>
      </div>

      {/* License Image */}
      <div className="license-content">
        <div className="license-image-container">
          <img 
            src="/images/license-certificate.jpg" 
            alt="ใบอนุญาต"
            className="license-image"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
          <div className="license-placeholder" style={{ display: 'none' }}>
            <p>ไม่พบรูปภาพใบอนุญาต</p>
            <p style={{ fontSize: '12px', color: '#999', marginTop: '8px' }}>
              กรุณาเพิ่มรูปภาพที่ /public/images/license-certificate.jpg
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default License;

